import { rem } from 'polished';
import styled from 'styled-components';

export const Wrapper = styled.div`
    width: ${rem(90)};
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${rem(0)} ${rem(15)};
    border-radius: ${rem(4)};
    border: 1px solid ${({ theme }) => theme.colors.secondaryGrey};
`;

export const Minus = styled.span`
    cursor: pointer;
    font-size: ${({ theme }) => theme.fontSizes.h4};
    margin-bottom: ${rem(4)};
`;

export const Quantity = styled.span`
    font-size: ${({ theme }) => theme.fontSizes.textMedium};
`;

export const Plus = styled.span`
    cursor: pointer;
    font-size: ${({ theme }) => theme.fontSizes.h5};
    margin-bottom: ${rem(2)};
`;
